import { Injectable } from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot} from '@angular/router';
import { AuthService} from '../auth/auth.service';

@Injectable()
export class UnauthGuardService implements CanActivate {
    constructor(public auth: AuthService, public router: Router) {}
    canActivate(route: ActivatedRouteSnapshot): boolean {
      const token = route.queryParams['token'];
      if (token) {
        this.auth.setToken(token);
      }
        if (this.auth.isLoggedIn()) {
            this.router.navigate(['/']);
            return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./client/app/core/guards/unauth-guard.ts